export const euCountryCodes = [
    //EU countries [https://publications.europa.eu/code/pdf/370000en.htm - 20.07.2021]
    "BE",
    "BG",
    "CZ",
    "DK",
    "DE",
    "EE",
    "IE",
    "EL",
    "ES",
    "FR",
    "HR",
    "IT",
    "CY",
    "LV",
    "LT",
    "LU",
    "HU",
    "MT",
    "NL",
    "AT",
    "PL",
    "PT",
    "RO",
    "SI",
    "SK",
    "FI",
    "SE",
    //EU candidate countries [https://publications.europa.eu/code/pdf/370000en.htm - 20.07.2021]
    "ME",
    "MK",
    "AL",
    "RS",
    "TR",
    //European Free Trade Association (EFTA) [https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:Country_codes - 20.07.2021]
    "IS",
    "NO",
    "LI",
    "CH",
    //Potential candidates (all other Western Balkan countries) [https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:Country_codes - 20.07.2021]
    "BA",
    "XK",
    //custom added countries
    "AX",
    "AD",
    "IC",
    "GR",
    "MD",
    "MC",
    "SM",
    "UA",
];

export function getContinentCode(country) {
    if (euCountryCodes.includes(country.isoCode2)) {
        return "EU";
    }

    return "not_EU";
}

export function getCurrencyByCountry(country, continentCode) {
    switch (country.isoCode2) {
        case "SE":
            if (
                App.initialData.currencies.some(
                    (currency) => currency.name === "SEK"
                )
            ) {
                return "SEK";
            }
            break;
        case "DK":
        case "GL":
        case "FO":
            if (
                App.initialData.currencies.some(
                    (currency) => currency.name === "DKK"
                )
            ) {
                return "DKK";
            }
            break;
        case "NO":
            if (
                App.initialData.currencies.some(
                    (currency) => currency.name === "NOK"
                )
            ) {
                return "NOK";
            }
            break;
        case "PL":
            if (
                App.initialData.currencies.some(
                    (currency) => currency.name === "PLN"
                )
            ) {
                return "PLN";
            }
            break;
        case "GB":
        case "GI":
        case "GG":
        case "IM":
        case "JE":
        case "XI":
            if (
                App.initialData.currencies.some(
                    (currency) => currency.name === "GBP"
                )
            ) {
                return "GBP";
            }
            break;
    }

    if (continentCode === "EU") {
        return "EUR";
    }

    return "USD";
}
